import { render, staticRenderFns } from "./ConvertForm.vue?vue&type=template&id=b638d214&"
import script from "./ConvertForm.vue?vue&type=script&lang=js&"
export * from "./ConvertForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports